var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { SVGIcon, SVGIconGroup, SVGIconPath } from '../../components/SVGIcon';
var TimeCircleIconShape = React.createElement(SVGIconGroup, null, React.createElement(SVGIconPath, {
  d: "M12,2 C17.5201823,2.00642897 21.993571,6.47981766 22,12 C22,17.5228475 17.5228475,22 12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 Z M12,3.66666667 C7.39762708,3.66666667 3.66666667,7.39762708 3.66666667,12 C3.66666667,16.6023729 7.39762708,20.3333333 12,20.3333333 C16.6002787,20.3282814 20.3282814,16.6002787 20.3333333,12 C20.3333333,7.39762708 16.6023729,3.66666667 12,3.66666667 Z M11.5833333,6.58333333 C12.0435706,6.58333333 12.4166667,6.95642938 12.4166667,7.41666667 L12.4166667,7.41666667 L12.4166667,11.6341667 L16.2783333,15.175 C16.6172562,15.485787 16.6403781,16.0123692 16.33,16.3516667 C16.0168393,16.6864524 15.4933476,16.7090518 15.1525,16.4025 L15.1525,16.4025 L11.02,12.615 C10.847713,12.456952 10.7497433,12.2337988 10.7499995,12 L10.7499995,12 L10.7499995,7.41666667 C10.7499995,6.95642938 11.123096,6.58333333 11.5833333,6.58333333 Z"
}));
export var TimeCircleIcon = function TimeCircleIcon(props) {
  var className = props.className,
      restProps = __rest(props, ["className"]);

  return React.createElement(SVGIcon, Object.assign({}, restProps, {
    className: "TimeCircleIcon ".concat(className || '')
  }), TimeCircleIconShape);
};